import {
  IconDashboard,
  IconShield,
  IconBuilding,
  IconVault,
  IconInbox,
  IconClipboard,
} from '../../ui/icons';
import { WorkspaceNav } from '../WorkspaceNav';

/**
 * Icon-rail navigation for the Custodian workspace.
 * Destinations match CustodianSidebar — no route paths change.
 */
const sections = [
  {
    items: [
      { to: '/custodian', label: 'Dashboard', Icon: IconDashboard, end: true },
      { to: '/custodian/awaiting-review', label: 'Awaiting Review', Icon: IconShield },
      { to: '/custodian/explorer', label: 'Custody Explorer', Icon: IconBuilding },
      { to: '/custodian/assets', label: 'Asset Register', Icon: IconVault },
    ],
  },
  {
    label: 'Execution queues',
    items: [{ to: '/custodian/release-copy', label: 'Release & Copy', Icon: IconInbox }],
  },
  {
    label: 'Records & discover',
    items: [
      {
        to: '/custodian/evidence/certified-copies',
        label: 'Evidence & Certificates',
        Icon: IconClipboard,
      },
    ],
  },
];

export function CustodianIconRail() {
  return <WorkspaceNav ariaLabel="Custodian navigation" sections={sections} />;
}
